<template>
    <div>
        <v-card color="light">
            <v-card-title>
                Carrier and Services Mapping <v-spacer></v-spacer>
                <div :style="{
                    width: '200px',
                    position: 'absolute',
                    right: '20px',
                    top: '5px',
                    textAlign: 'right'
                }">
                    <v-tooltip
                        bottom
                        :max-width="300">
                        <template v-slot:activator="{ on }">
                            <v-btn
                                icon
                                v-on="on"
                                color="secondary"
                                type="button"
                                class="mt-3"
                                :disabled="isRefreshing"
                                @click="onRefresh"
                            >
                                <v-progress-circular
                                    v-if="isRefreshing"
                                    indeterminate
                                    color="secondary">
                                </v-progress-circular>
                                <v-icon v-else>mdi-refresh-circle</v-icon>
                            </v-btn>
                        </template>
                        <span>This button will refresh carrier and services.</span>
                    </v-tooltip>
                </div>
            </v-card-title>
            <v-form
                ref="form"
                class="pt-0"
                v-if="!isRefreshing"
                @submit="onSubmit">
                <v-container fluid>

                    <v-row>
                        <v-col v-if="shipping_methods.length > 0" lg="3" md="4">
                            <v-select
                                v-model="shipping_method"
                                ref="shipping_method"
                                :items="shipping_methods"
                                label="Shipping Methods"
                                @change="onShippingMethodSelected"
                                :rules="[v => !!v || 'Shipping Method is required']"
                            />
                        </v-col>

                        <v-col v-if="shipping_methods.length == 0 || showCustomShippingMethod" lg="3" md="4">
                            <v-text-field
                                v-model="method_label"
                                label="Shipping Method Label"/>
                        </v-col>
                        <v-col v-if="shipping_methods.length == 0 || showCustomShippingMethod" lg="3" md="4">
                            <v-text-field
                                v-model="method_value"
                                label="Shipping Method Value"
                                :rules="[v => !!v || 'Method value is required']" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <!-- carrier -->
                        <v-col lg="3" md="4" sm="12">
                            <v-autocomplete
                                v-model="carrier"
                                :items="carriers"
                                menu-props="auto"
                                label="Carrier"
                                ref="carrier"
                                :rules="[v => !!v || 'Carriers is required']"
                            />
                        </v-col>

                        <!-- carrier service -->
                        <v-col lg="3" md="4" sm="12">
                            <v-autocomplete
                                v-if="carrier && carrier.name != 'Skip'"
                                v-model="carrierService"
                                :items="carrierServices"
                                menu-props="auto"
                                label="Carrier Services"
                                ref="service"
                                :rules="[v => !!v || 'Carrier service is required']"
                            />
                        </v-col>

                        <!-- carrier account -->
                        <v-col lg="3" md="4" sm="12">
                            <v-autocomplete
                                v-if="carrier && carrier.name != 'Skip'"
                                v-model="carrierAccount"
                                :items="carrierAccounts"
                                menu-props="auto"
                                label="Carrier Account"
                                ref="carrierAccount"
                            />
                        </v-col>

                        <v-col v-if="item_edit" class="text-right">
                            <v-btn small class="mt-3" @click="onEditClose">Close</v-btn>
                            <v-btn small type="submit" class="mt-3" color="primary">
                                <span v-if="isSubmit">
                                    <v-progress-circular
                                        indeterminate
                                        size="12"
                                        width="2"
                                        color="primary darken-3">
                                    </v-progress-circular>
                                    Updating..
                                </span>
                                <span v-else>Update</span>
                            </v-btn>
                        </v-col>
                        <v-col v-else class="text-right">
                            <v-btn small type="submit" class="mt-3" color="primary">
                                <span v-if="isSubmit">
                                    <v-progress-circular
                                        indeterminate
                                        size="12"
                                        width="2"
                                        color="primary darken-3">
                                    </v-progress-circular>
                                    Adding..
                                </span>
                                <span v-else>Add</span>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
            <CarrierServiceMaps
                v-if="integrationId"
                ref="csm"
                :integrationId="integrationId"
                @mapped="onMapped"
                @onEdit="onEdit"
            />
        </v-card>
    </div>
</template>

<script>
import { EventBus } from '../../../../event-bus.js'
import CarrierServiceMaps from './CarrierServiceMaps'
import { mapGetters, mapState } from "vuex"

export default {
    props: {
        id: { type: Number, default: null },
        metas: { type: Array, default: [] }
    },
    components: {
        CarrierServiceMaps
    },
    data() {
        return {

            method_label: null,
            method_value: null,
            carrier: null,
            carrierService: null,
            carrierServices: [],
            carrierAccount: null,
            carrierAccounts: [],
            carriers: [],

            isSubmit: false,
            isRefreshing: false,

            integrationType: null,

            item_edit: null,
            mapped: [],

            shipping_method: null,
            shipping_methods: [],
            showCustomShippingMethod: false
        }
    },

    mounted() {

        this.fetchCarriers()
        this.fetchShippingMethods()
    },

    watch: {
        carrier(value) {
            if (value && value.id == 0) {
                this.carrierService = {id: 0, name: 'Skip'}
                this.carrierServices = []
            } else if (value) {
                let carrier_value = value.value ? value.value : value
                this.mapCarrierServiceAndAccounts(carrier_value)
            }
        },
        shipping_method(shippingMethod) {
            this.showCustomShippingMethod = false
            if (shippingMethod == 'custom') {
                this.method_label = ''
                this.method_value = ''
                this.showCustomShippingMethod = true
            } else if(shippingMethod?.value == 'custom') {
                this.showCustomShippingMethod = true
            }
        },
    },

    computed: {

        ...mapGetters({ integrations: 'getIntegrations'}),
        integrationId() {
            return this.id ?? parseInt(window.location.pathname.split('/')[2])
        },

        integrationLabel() {

            if (this.integrations) {
                let current = this.integrations.find(integ => integ.id == this.integrationId)
                return current?.attributes?.label
            }

            return ""
        },
    },


    methods: {

        // this will fetch shipping methods
        async fetchShippingMethods() {
            this.shipping_methods = []
            this.isRefreshing = true;

            this.shipping_methods.push({
                text: 'Custom',
                value: 'custom'
            })

            await this.$http
                .get(`/api/valuelookups/carriers/${this.integrationId}/shippingmethods`)
                .then(({ data }) => {
                    if (data.status) {
                        data.result.map(item => {
                            this.shipping_methods.push({
                                text: item.text,
                                value: item.value
                            })
                        })
                    }
                })
                .finally(() => {
                    this.isRefreshing = false;
                })
                .catch(err => EventBus.$emit('show-error', err))
        },

        // this will fetch carrier options
        async fetchCarriers() {
            try {
                let res = await this.$http.get('/api/machship/carriers', {
                    params: { integration_id: this.integrationId }
                })

                if (!res || !res.status ) {
                    console.log("[CARRIER_SERVICE] unable to get carrier result", res)
                    return;
                }

                const { result } = res.data

                if (!result) {
                    console.warn("Unable to fetch carrier and its services of " + this.integrationLabel)
                    return
                }

                this.carriers = result.map(carrier => {
                    return {
                        value: carrier,
                        text: carrier.name
                    }
                })

                this.carriers.push({
                    value: {id: 0, name: 'Skip'},
                    text: "SKIP"
                })


            } catch (error) {
                EventBus.$emit('show-error', "Unable to fetch carrier and its services of " + this.integrationLabel)
                console.log("[CARRIER_SERVICE] error", error);
                this.carriers = []
            }
        },


        // this will map carrier services and accounts from a specific carrier
        mapCarrierServiceAndAccounts(carrier) {

            this.carrierAccounts = [];
            this.carrierServices = [];


            if (carrier.carrierAccounts) {

                carrier.carrierAccounts.forEach(account => {
                    this.carrierAccounts.push({
                        value: account,
                        text: account.name
                    });

                    this.carrierServices = account.carrierServices.map(cservice => ({
                        value: cservice,
                        text: cservice.name
                    }))
                })
            }

            this.carrierServices.push({
                value: {id: 0, name: 'Skip'},
                text: "SKIP"
            })

            this.carrierAccounts.push({
                value: {id: 0, name: 'Skip'},
                text: "SKIP"
            })


            // check if the form is for edit
            if (this.item_edit) {
                this.carrierAccount =  this.carrierAccounts.find(account => account.value.id == this.item_edit.account_id)
                if (this.carrierAccount) {
                    this.carrierAccount.id = this.item_edit.account_id
                    this.carrierAccount.name = this.item_edit.account
                }

                this.carrierService =  this.carrierServices.find(service => service.value.id == this.item_edit.service_id)
                if (this.carrierService) {
                    this.carrierService.id = this.item_edit.service_id
                    this.carrierService.name = this.item_edit.service
                }
            }

        },

        // inserting new carrier service map
        onSubmit(e) {
            e.preventDefault()

            if (this.$refs.form.validate()) {
                this.isSubmit = true
                let params = {
                    integration_id: this.integrationId,
                    method_label: this.method_label,
                    method_value: this.method_value,
                    carrier_id: this.carrier.id,
                    carrier_name: this.carrier.name,
                    carrier_service_name: this.carrierService.name ? this.carrierService.name : this.carrierService.text,
                    carrier_service_id: this.carrierService.id,
                    carrier_account_name: this.carrierAccount.name ? this.carrierAccount.name : this.carrierAccount.text,
                    carrier_account_id: this.carrierAccount.id
                }

                // Note: only for carrier service edit
                if (this.item_edit) {
                    params.old_from_value = this.item_edit.method_value
                }

                // determine the type of request
                let request = this.item_edit ?
                        this.$http.put('/api/valuelookups/carriers', params) :
                        this.$http.post('/api/valuelookups/carriers', params)

                // execute request here
                request.then(({ data }) => {
                    if (data.status) {
                        EventBus.$emit('show-success', "Successfully saved carrier service mapping!");
                        this.$refs.form.reset()
                        this.item_edit = null

                        // now we need to reload carrier service mapped component
                        this.$refs.csm.fetchMappingCarrierServices()

                    } else {
                        EventBus.$emit('show-error', data.message);
                    }
                    this.isSubmit = false
                })
                .catch(err => {
                    this.isSubmit = false
                    EventBus.$emit('show-error', err)
                })
            } else {
                EventBus.$emit('show-error', "Fail to save carrier service mapping! please try again.");
            }

        },

        // on edit carrier service map
        onEdit(map) {
            this.item_edit = map
            this.method_label = map.method_label
            this.method_value = map.method_value
            this.carrier = this.carriers.find(carrier => carrier.value.id == map.carrier_id)
            if (this.carrier && this.carrier.text != 'SKIP') {
                this.carrier.id = map.carrier_id
                this.carrier.name = map.carrier
            } else {
                this.carrier = { id: 0, name: 'Skip' }
            }

            this.shipping_method = this.shipping_methods.find(shipping_method => shipping_method.value == map.method_value)
            if(this.shipping_method == null) {
                this.shipping_method = { value: 'custom' }
            }

            this.$vuetify.goTo(this.$refs.form, {
                duration: 300,
                offset: 0,
                easing: 'easeInOutCubic',
            })
        },

        // on close or cancel edit
        onEditClose(e) {
            e.preventDefault()
            this.item_edit = null
            this.$refs.form.reset()
        },

        // listen to mapped items
        onMapped(items) {
            this.mapped = items
        },

        // listen to shipping methods selected
        onShippingMethodSelected(value) {

            // Get the selected item
            const selectedItem = this.shipping_methods.find(item => item.value === value);

            this.method_value = this.method_label = '';
            if(selectedItem.value != 'custom') {
                // Set the selected value and text
                this.method_value = selectedItem.value;
                this.method_label = selectedItem.text;
            }

        },

        // on refresh carrier and services
        async onRefresh() {
            try {
                this.isRefreshing = true
                await this.$http.post('/api/machship/refresh', { integration_id : this.integrationId })
                this.fetchCarriers()
                EventBus.$emit('show-success', "Successfully refresh carrier and service")
            } catch (err) {
                EventBus.$emit('show-error', err)
            }


            this.isRefreshing = false
        },

        // listen from shipping methods refreshed
        onShippingMethodRefreshed() {
            this.fetchCarriers()
            this.$refs.csm.fetchMappingCarrierServices()
        },
    }

}

</script>